/**
 * CMS "Require user input" — only explicit boolean true counts (not sticky, not undefined).
 */
export function isForceInputRequired(question) {
  return question?.properties?.options?.forceInput === true;
}

/**
 * Missing answer for validation when forceInput is required.
 * Treats 0 and false as valid (e.g. slider minimum); rejects null, undefined, '', empty array, and NaN.
 */
export function isAnswerMissingForQuestionnaire(answer) {
  if (answer === null || answer === undefined) return true;
  if (typeof answer === 'number' && Number.isNaN(answer)) return true;
  if (typeof answer === 'string' && answer.trim() === '') return true;
  if (Array.isArray(answer) && answer.length === 0) return true;
  return false;
}
